import { Link } from "react-router-dom";
import { Zap, Clock, ArrowRight } from "lucide-react";
import { timeAgo } from "@/lib/api";

export default function BreakingNewsBanner({ article }) {
  if (!article) return null;
  return (
    <Link
      to={`/nota/${article.slug}`}
      className="block relative overflow-hidden border-[3px] rounded-sm group"
      style={{ borderColor: "#FF1B1B", background: "#0A0A0A" }}
      data-testid="breaking-news-banner"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 min-h-[260px]">
        <div className="md:col-span-6 lg:col-span-5 p-5 md:p-7 lg:p-9 flex flex-col justify-between gap-5 relative z-10 text-white">
          <div className="flex flex-wrap items-center gap-3">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-sm font-bold text-sm uppercase tracking-widest" style={{ background: "#FF1B1B", color: "#FFF" }}>
              <Zap size={14} fill="currentColor" /> ÚLTIMO MOMENTO
            </span>
            <span className="text-xs uppercase tracking-widest font-bold opacity-90">{article.category_slug?.toUpperCase()}</span>
            <span className="text-xs uppercase tracking-widest opacity-60">· {timeAgo(article.published_at)}</span>
          </div>
          <h2 className="font-headline uppercase text-2xl md:text-3xl lg:text-4xl leading-[0.95] tracking-tight">
            {article.title}
          </h2>
          <p className="text-sm md:text-base text-white/75 leading-relaxed line-clamp-3">{article.bajada}</p>
          <div className="flex items-center justify-between gap-3 flex-wrap">
            <span className="flex items-center gap-1.5 text-xs uppercase tracking-widest opacity-70"><Clock size={12} /> {new Date(article.published_at).toLocaleTimeString("es-AR", { hour: "2-digit", minute: "2-digit" })} HS</span>
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-sm font-bold text-xs uppercase tracking-widest text-white group-hover:opacity-90 transition" style={{ background: "#FF1B1B" }}>
              SEGUIR COBERTURA EN VIVO <ArrowRight size={14} />
            </span>
          </div>
        </div>
        <div className="md:col-span-6 lg:col-span-7 relative min-h-[200px] md:min-h-full">
          {article.featured_image && (
            <img src={article.featured_image} alt={article.title} className="absolute inset-0 w-full h-full object-cover" />
          )}
          <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, #0A0A0A 0%, rgba(10,10,10,0.5) 35%, transparent 70%)" }} />
          <span className="absolute top-4 right-4 px-3 py-1.5 rounded-sm font-bold text-xs uppercase tracking-widest text-white" style={{ background: "#FF1B1B" }}>
            EN DESARROLLO
          </span>
        </div>
      </div>
    </Link>
  );
}
